import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AutorSection from "./components/AutorSection";
import HistoriaSection from "./components/HistoriaSection";
import VirgenSection from "./components/VirgenSection";
import PorQueSection from "./components/PorQueSection";
import CierreSection from "./components/CierreSection";

export default function Home() {
  return (
    <main className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <AutorSection />
      <HistoriaSection />
      <PorQueSection />
      <VirgenSection />
      <CierreSection />
    </main>
  );
}
